// types
import { OBJECTS_COLLECTION, TRAINING_COLLECTION } from "../constants/firebase/constants";
import { IObjectType, ITaskSubTypes } from "./object/object";
import { TrainingType } from "./training";

// oxlint-disable-next-line no-shadow
export enum EnumLinkTypes {
  "RelatesTo" = "relates to",
  "Blocks" = "blocks",
  "BlockedBy" = "blocked by",
  "Causes" = "caused",
  "CausedBy" = "caused by",
  "ReplacedBy" = "replaced by",
  "Replaces" = "replaces",
  "Child" = "child",
  "Parent" = "parent",
  "Source" = "Source",
  "DuplicateOf" = "DuplicateOf",
  "LinkedTo" = "linked to",
}

// oxlint-disable-next-line no-shadow
export enum EnumEntityTemplateType {
  "form" = "form",
  "issue" = "issue",
  "corrective-action" = "corrective-action",
  "trainingInstance" = "training-instance",
}

export interface EntityInstanceLink {
  linkType: EnumLinkTypes;
  targetId: string;
  targetType: EnumEntityTemplateType | IObjectType | ITaskSubTypes | TrainingType | "share";
  linkKey?: string;
  meta?: { [key: string]: unknown };
}

export const isEntityInstanceLink = (value: unknown): value is EntityInstanceLink => {
  if (typeof value !== "object" || value === null) {
    return false;
  }

  if (!("meta" in value)) {
    return false;
  }

  const meta = value.meta;

  return typeof meta === "object"
    && meta !== null
    && "linksFormPath" in meta;
};

const TRAINING_TARGET_TYPES: ReadonlySet<string> = new Set<string>([
  TrainingType.training,
  TrainingType.competencies,
  TrainingType.certification,
  EnumEntityTemplateType.trainingInstance,
]);

const TASK_TARGET_TYPES: ReadonlySet<string> = new Set<string>([
  ITaskSubTypes["corrective-action"],
  ITaskSubTypes["issue"],
]);

/**
 * Returns the web route segment for a given object link target type.
 * - task sub-types → "task"
 * - training types → "training"
 * - everything else (forms) → "form"
 */
export function getEntityLinkRoutePath(
  targetType: EntityInstanceLink["targetType"],
): IObjectType.form | IObjectType.task | TrainingType.training {
  if (TASK_TARGET_TYPES.has(targetType)) {
    return IObjectType.task;
  }

  if (TRAINING_TARGET_TYPES.has(targetType)) {
    return TrainingType.training;
  }
  return IObjectType.form;
}

export function getEntityDocumentPath(targetType: EntityInstanceLink["targetType"]) {
  if (TRAINING_TARGET_TYPES.has(targetType)) {
    return TRAINING_COLLECTION;
  }
  return OBJECTS_COLLECTION;
}
